import api from 'api';

export const loadBusinessPartners = api(
  'GET /api/partner-users/fields/business-partners'
);

export const loadActions = api('GET /api/partner-users/fields/actions');
export const loadAffiliates = api('GET /api/partner-users/fields/affiliates');
export const loadApplications = api(
  'GET /api/partner-users/fields/applications'
);

export const loadBPAffiliates = api(
  'GET /api/partner-users/fields/bpaffiliates'
);
